/**
 * @generated SignedSource<<b1e13ea43ed60872b3d204941f1ac056>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type rbacCheckQuery$variables = {
  isForGoals: boolean;
  isForProjects: boolean;
  workspaceUuid: string;
};
export type rbacCheckQuery$data = {
  readonly workspaceByUuid: {
    readonly aiConfig: {
      readonly enabled: boolean;
    } | null;
    readonly aiPermittedForGoals?: boolean;
    readonly aiPermittedForProjects?: boolean;
  } | null;
};
export type rbacCheckQuery = {
  response: rbacCheckQuery$data;
  variables: rbacCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isForGoals"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isForProjects"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v3 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "workspaceUuid"
  }
],
v4 = {
  "concreteType": "WorkspaceAIConfig",
  "kind": "LinkedField",
  "name": "aiConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "enabled"
    }
  ]
},
v5 = {
  "condition": "isForGoals",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aiPermittedForGoals"
    }
  ]
},
v6 = {
  "condition": "isForProjects",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aiPermittedForProjects"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "rbacCheckQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceByUuid",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "rbacCheckQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceByUuid",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8ce24a1f38abdaaafdc606901945924d",
    "id": null,
    "metadata": {},
    "name": "rbacCheckQuery",
    "operationKind": "query",
    "text": "query rbacCheckQuery(\n  $workspaceUuid: UUID!\n  $isForGoals: Boolean!\n  $isForProjects: Boolean!\n) {\n  workspaceByUuid(uuid: $workspaceUuid) {\n    aiConfig {\n      enabled\n    }\n    aiPermittedForGoals @include(if: $isForGoals)\n    aiPermittedForProjects @include(if: $isForProjects)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e657aa7085e4819ad9f02e2b00da7625";

export default node;
